export { default } from './IconAffix.js';
